<script setup>
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";

import { XMarkIcon } from "@heroicons/vue/20/solid";

import { useQuizStore } from "@/stores/quiz";
const quizStore = useQuizStore();
const router = useRouter();
const route = useRoute();
const props = defineProps({
  quizId: {
    type: String,
    default: null,
  },
  questionId: {
    type: String,
    default: null,
  },
  userId: {
    type: String,
    default: null,
  },
  user: {
    type: Object,
    default: null,
  },
});
const reset = () => {
  quizStore.reset();
  router.push({
    name: "home",
  });
};
if (document.location.search.includes("preview=1")) {
  reset();
}
const isDev = document.location.hostname.match(/(localhost|monudi.test)/);
const showDebug = false && isDev;

quizStore.setUserId(props.userId);
quizStore.setUser(JSON.parse(props.user));

if (props.quizId)
  fetch(`${import.meta.env.VITE_QUIZ_API_ENDPOINT}/quiz/${props.quizId}/full`)
    .then((r) => r.json())
    .then((quiz) => {
      quizStore.setQuiz(quiz);
    })
    .catch((error) => {
      console.log(error);
    });

if (props.questionId)
  fetch(
    `${import.meta.env.VITE_QUIZ_API_ENDPOINT}/question/${
      props.questionId
    }/full`
  )
    .then((r) => r.json())
    .then((quiz) => {
      quizStore.setQuestion(quiz);
      router.push({
        name: "question-preview",
      });
    })
    .catch((error) => {
      console.log(error);
    });

const close = () => {
  document.location.href = document.location.pathname;
  // document.getElementById("quiz-container").innerHTML = "";
  // document.querySelector("body").style.overflow = "auto";
};
</script>

<template>
  <div
    id="quiz_content"
    class="fixed inset-0 z-[99999] overflow-y-auto transition-opacity bg-white lg:max-w-[80%] lg:ml-auto"
  >
    <button
      class="fixed z-[99999] w-2 h-2 text-center text-black top-2 right-1 lg:text-white lg:bg-none lg:top-1/2 lg:left-[10%] lg:right-auto lg:-translate-x-full"
      @click="close()"
    >
      <svg
        width="20"
        height="20"
        class="inline w-1.25 h-1.25 fill-current lg:w-4 lg:h-4"
      >
        <use xlink:href="#icon-close" />
      </svg>
    </button>
    <div
      class="flex items-start justify-center min-h-screen p-0 text-center lg:px-4 lg:py-1 sm:p-0"
    >
      <div
        class="relative ml-0 overflow-hidden text-left transition-all transform bg-white xl:mx-4 sm:w-full sm:max-w-full"
        v-if="quizStore.quiz.id || quizStore.question.id"
      >
        <button
          class="fixed z-[99999] top-2 left-2 bt"
          @click="reset()"
          v-if="isDev && quizStore.quiz.id"
        >
          reset
        </button>

        <router-view v-slot="{ Component, route }">
          <!-- <transition name="fade"> -->
          <Suspense :key="route.path">
            <component :is="Component" />
          </Suspense>
          <!-- </transition> -->
        </router-view>
      </div>
    </div>
  </div>
  <div
    class="absolute top-0 left-0 z-[99999] w-1/4 p-0 text-white opacity-50 text-normal bg-dark bottom-0 overflow-auto"
    v-if="showDebug && quizStore.quiz.id"
  >
    {{
      {
        // route: route.path,
        // quizId: quizStore.quiz.id,
        // segmentID: quizStore.currentSegmentId,
        // questionId: quizStore.currentQuestionId,
        startedAt: quizStore.startedAt,
        getSegmentScore: quizStore.getSegmentScore(quizStore.currentSegmentId),
        totalScore: quizStore.getScore(),
        // getScores: quizStore.getScores(),
        answers: quizStore.answers,
        // next: quizStore.nextQuestion(),
        // quiz: quizStore.quiz.segments,
      }
    }}
  </div>
  <div class="z-50 goverlay"></div>
</template>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
